// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-swbl-lstdtj-index-main_right_content-1RR7G","white_backgroud":"components-swbl-lstdtj-index-white_backgroud-2pebt"};


//////////////////
// WEBPACK FOOTER
// ./components/swbl/lstdtj/index.css
// module id = 1919
// module chunks = 0